import React, {FC} from "react";
import {CustomersSimpleReportSearchParamsModel, PageEnum} from "../../../models";
import {ReportCustomersSimpleSearchPanel, ReportPage,} from "../../../components";
import {SearchReportCustomersData} from "../../../serviceBroker/customersReportApiServiceBroker";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";

export const ReportCustomersData: FC = () => {
    const initialState: CustomersSimpleReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={SearchReportCustomersData}
            searchHeader={getPageNameByPageId(PageEnum.ReportCustomersData)}
            SearchPanel={ReportCustomersSimpleSearchPanel}
            formId={PageEnum.ReportCustomersData}
        />
    );
};
